import type { ReactElement } from 'react';
import { useShippingFeeSettingsQuery } from '@/entities/shipping-fee';
import { ShippingFeeSettingsForm } from '@/features/shipping-fee/settings';
import { ContentCard, EmptyState } from '@/shared/ui';

/**
 * 배송비 설정(/settings/shipping-fee, SUPER-86 D9) — 기본·제주 추가·도서산간 추가 금액을 한 번의 조회로 보인다. 저장 뒤 새 설정이
 * 오면(updatedAt 이 바뀐다) 폼을 key 로 다시 시작해 새 값을 보인다.
 */
export const ShippingFeeSettingsPanel = (): ReactElement => {
  const settingsQuery = useShippingFeeSettingsQuery();

  if (settingsQuery.isPending) {
    return <EmptyState>배송비 설정을 불러오는 중…</EmptyState>;
  }

  if (settingsQuery.isError) {
    return (
      <EmptyState isError>
        {`배송비 설정을 불러오지 못했습니다: ${settingsQuery.error.message}`}{' '}
        <button type="button" className="underline" onClick={() => void settingsQuery.refetch()}>
          다시 시도
        </button>
      </EmptyState>
    );
  }

  const settings = settingsQuery.data;
  return (
    <ContentCard title="배송비 금액">
      <ShippingFeeSettingsForm key={settings.updatedAt ?? 'initial'} settings={settings} />
    </ContentCard>
  );
};
